// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myBtn {
  background-color: var(--white-color);
  font-size: 16px;
  font-weight: 700;
  padding: 0px 70px;
  height: 58px;
  width: auto;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  color: var(--dark-heading-text);
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  background-image: linear-gradient(
    to right,
    var(--primary-color),
    var(--primary-color)
  );
  background-repeat: no-repeat;
  background-size: 0% 100%;
  /* transition: background-size 1.5s ease; */
  transition: background-size 0.8s cubic-bezier(0.25, 1, 0.8, 1), color 0.8s ease;
}

.myBtn:hover {
  background-size: 100% 100%;
  color: var(--white-color);
}

@keyframes hoverSpread {
  from {
    background-size: 0% 100%; 
  }
  to {
    background-size: 100% 100%; 
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Auth/Contact GetStart btn/BtnStyle.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,qDAAqD;EACrD;;;;GAIC;EACD,4BAA4B;EAC5B,wBAAwB;EACxB,2CAA2C;EAC3C,+EAA+E;AACjF;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".myBtn {\n  background-color: var(--white-color);\n  font-size: 16px;\n  font-weight: 700;\n  padding: 0px 70px;\n  height: 58px;\n  width: auto;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  color: var(--dark-heading-text);\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  background-image: linear-gradient(\n    to right,\n    var(--primary-color),\n    var(--primary-color)\n  );\n  background-repeat: no-repeat;\n  background-size: 0% 100%;\n  /* transition: background-size 1.5s ease; */\n  transition: background-size 0.8s cubic-bezier(0.25, 1, 0.8, 1), color 0.8s ease;\n}\n\n.myBtn:hover {\n  background-size: 100% 100%;\n  color: var(--white-color);\n}\n\n@keyframes hoverSpread {\n  from {\n    background-size: 0% 100%; \n  }\n  to {\n    background-size: 100% 100%; \n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
